module.exports = __webpack_public_path__ + "static/img/13.9f1d2f9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/2/zh/13.png
// module id = CewE
// module chunks = 0